import { createAction, props } from '@ngrx/store';

export const loadCampaignList = createAction(
  '[Campaign] Load CampaignList',
  props<any>()
);

export const loadCampaignListSuccess = createAction(
  '[Campaign] Load CampaignList Success',
  props<{ data: any }>()
);

export const loadCampaignListFailure = createAction(
  '[Campaign] Load CampaignList Failure',
  props<{ error: any }>()
);

export const loadEditCampaignList = createAction(
  '[Campaign] Load EditCampaignList',
  props<any>()
);

export const loadEditCampaignListSuccess = createAction(
  '[Campaign] Load EditCampaignList Success',
  props<{ data: any }>()
);

export const loadEditCampaignListFailure = createAction(
  '[Campaign] Load EditCampaignList Failure',
  props<{ error: any }>()
);

export const loadEventCampaignList = createAction(
  '[Campaign] Load EventCampaignList',
  props<any>()
);

export const loadEventCampaignListSuccess = createAction(
  '[Campaign] Load EventCampaignList Success',
  props<{ data: any }>()
);

export const loadEventCampaignListFailure = createAction(
  '[Campaign] Load EventCampaignList Failure',
  props<{ error: any }>()
);

export const loadManageCampaignList = createAction(
  '[Campaign] Load ManageCampaignList',
  props<any>()
);

export const loadManageCampaignListSuccess = createAction(
  '[Campaign] Load ManageCampaignList Success',
  props<{ data: any }>()
);

export const loadManageCampaignListFailure = createAction(
  '[Campaign] Load ManageCampaignList Failure',
  props<{ error: any }>()
);

export const loadReportCampaignList = createAction(
  '[Campaign] Load ReportCampaignList',
  props<any>()
);

export const loadReportCampaignListSuccess = createAction(
  '[Campaign] Load ReportCampaignList Success',
  props<{ data: any }>()
);

export const loadReportCampaignListFailure = createAction(
  '[Campaign] Load ReportCampaignList Failure',
  props<{ error: any }>()
);

export const loadPendingCampaignList = createAction(
  '[Campaign] Load PendingCampaignList',
  props<any>()
);

export const loadPendingCampaignListSuccess = createAction(
  '[Campaign] Load PendingCampaignList Success',
  props<{ data: any }>()
);

export const loadPendingCampaignListFailure = createAction(
  '[Campaign] Load PendingCampaignList Failure',
  props<{ error: any }>()
);

export const loadCampaign = createAction(
  '[Campaign] Load Campaign',
  props<any>()
);

export const loadCampaignSuccess = createAction(
  '[Campaign] Load Campaign Success',
  props<any>()
);

export const loadCampaignFailure = createAction(
  '[Campaign] Load Campaign Failure',
  props<{ error: any }>()
);


export const loadHinduDateLocations = createAction(
  '[Campaign] Load HinduDateLocations',
  props<any>()
);

export const loadHinduDateLocationsSuccess = createAction(
  '[Campaign] Load HinduDateLocations Success',
  props<{ data: any }>()
);

export const loadHinduDateLocationsFailure = createAction(
  '[Campaign] Load HinduDateLocations Failure',
  props<{ error: any }>()
);

export const createCampaign = createAction(
  '[Campaign] Create Campaign',
  props<any>()
);

export const createCampaignSuccess = createAction(
  '[Campaign] Create Campaign Success',
  props<any>()
);

export const createCampaignSuccessEmpty = createAction(
  '[Campaign] Create Campaign Success Empty',
  props<any>()
);

export const createCampaignFailure = createAction(
  '[Campaign] Create Campaign Failure',
  props<any>()
);

export const putCampaign = createAction(
  '[Campaign] Put Campaign',
  props<any>()
);

export const putCampaignSuccess = createAction(
  '[Campaign] Put Campaign Success',
  props<any>()
);

export const putCampaignSuccessEmpty = createAction(
  '[Campaign] Put Campaign Success Empty',
  props<any>()
);

export const putCampaignFailure = createAction(
  '[Campaign] Put Campaign Failure',
  props<any>()
);

export const putCampaignByProperties = createAction(
  '[Campaign settings] put campaign by properties',
  props<any>()
);

export const putCampaignByPropertiesSuccess = createAction(
  '[Campaign settings] put campaign by properties success',
  props<any>()
);

export const putCampaignByPropertiesFailure = createAction(
  '[Campaign settings] put campaign by properties failure',
  props<any>()
);


export const deleteCamapign = createAction(
  '[Campaign] Delete Campaign',
  props<any>()
);

export const deleteCamapignSuccess = createAction(
  '[Campaign] Delete Campaign Success',
  props<any>()
);

export const deleteCamapignFailure = createAction(
  '[Campaign] Delete Campaign Failure',
  props<any>()
);

export const activateCamapign = createAction(
  '[Campaign] Activate Campaign',
  props<any>()
);

export const activateCamapignSuccess = createAction(
  '[Campaign] Activate Campaign Success',
  props<any>()
);

export const activateCamapignFailure = createAction(
  '[Campaign] Activate Campaign Failure',
  props<any>()
);

export const setStatusCamapign = createAction(
  '[Campaign] Set Status Campaign',
  props<any>()
);

export const setStatusCamapignSuccess = createAction(
  '[Campaign] Set Status Campaign Success',
  props<any>()
);

export const setStatusCamapignFailure = createAction(
  '[Campaign] Set Status Campaign Failure',
  props<any>()
);

export const resetCamapign = createAction(
  '[Campaign] Reset Campaign',
  props<any>()
);

export const resetCamapignSuccess = createAction(
  '[Campaign] Reset Campaign Success',
  props<any>()
);

export const resetCamapignFailure = createAction(
  '[Campaign] Reset Campaign Failure',
  props<any>()
);

export const raffleDraw = createAction(
  '[Campaign] Raffle Draw',
  props<any>()
);

export const raffleDrawSuccess = createAction(
  '[Campaign] Raffle Draw Success',
  props<any>()
);

export const raffleDrawFailure = createAction(
  '[Campaign] Raffle Draw Failure',
  props<any>()
);

export const updateCampaign = createAction(
  '[Campaign] Update Campaign',
  props<any>()
);

export const updateCampaignStatus = createAction(
  '[Campaign] Update Campaign Status',
  props<any>()
);

export const updateCampaignList = createAction(
  '[Campaign] Update Campaign List',
  props<any>()
);

export const selectCampaign = createAction(
  '[Campaign] Select Campaign',
  props<any>()
);

export const selectOption = createAction(
  '[Campaign] Select Option',
  props<any>()
);

export const clearCampaignList = createAction(
  '[Campaign] Clear CampaignList'
);

export const clearCampaignSelected = createAction(
  '[Campaign] Clear CampaignSelected'
);

export const updatePresetOptionSearch = createAction(
  '[Campaign] Update PresetOptionSearch',
  props<{ payload: string}>()
);

export const updateCampaignPresetOptionList = createAction(
  '[Campaign] Update Campaign Preset Option List',
  props<any>()
)

export const addCampaignPresetOption = createAction(
  '[Campaign] Add Campaign PresetOption',
  props<any>()
);

export const addCampaignPresetOptionSuccess = createAction(
  '[Campaign] Add Campaign PresetOption Success',
  props<any>()
);

export const addCampaignPresetOptionFailure = createAction(
  '[Campaign] Add Campaign PresetOption Failure',
  props<any>()
);

export const updateCampaignPresetOption = createAction(
  '[Campaign] Update Campaign PresetOption',
  props<any>()
);

export const updateCampaignPresetOptionSuccess = createAction(
  '[Campaign] Update Campaign PresetOption Success',
  props<any>()
);

export const updateCampaignPresetOptionFailure = createAction(
  '[Campaign] Update Campaign PresetOption Failure',
  props<any>()
);

export const deleteCampaignPresetOption = createAction(
  '[Campaign] Delete Campaign PresetOption',
  props<any>()
);

export const deleteCampaignPresetOptionSuccess = createAction(
  '[Campaign] Delete Campaign PresetOption Success',
  props<any>()
);

export const deleteCampaignPresetOptionFailure = createAction(
  '[Campaign] Delete Campaign PresetOption Failure',
  props<any>()
);

export const newAddCampaignPresetOption = createAction(
  '[Campaign] New Add Campaign PresetOption',
  props<any>()
);

export const newAddCampaignPresetOptionSuccess = createAction(
  '[Campaign] New Add Campaign PresetOption Success',
  props<any>()
);

export const newAddCampaignPresetOptionFailure = createAction(
  '[Campaign] New Add Campaign PresetOption Failure',
  props<any>()
);

export const newCreateCampaignPresetOption = createAction(
  '[Campaign] New Create Campaign PresetOption',
  props<any>()
);

export const newCreateCampaignPresetOptionSuccess = createAction(
  '[Campaign] New Create Campaign PresetOption Success',
  props<any>()
);

export const newCreateCampaignPresetOptionFailure = createAction(
  '[Campaign] New Create Campaign PresetOption Failure',
  props<any>()
);

export const newUpdateCampaignPresetOption = createAction(
  '[Campaign] New Update Campaign PresetOption',
  props<any>()
);

export const newUpdateCampaignPresetOptionSuccess = createAction(
  '[Campaign] New Update Campaign PresetOption Success',
  props<any>()
);

export const newUpdateCampaignPresetOptionFailure = createAction(
  '[Campaign] New Update Campaign PresetOption Failure',
  props<any>()
);

export const newDeleteCampaignPresetOption = createAction(
  '[Campaign] New Delete Campaign PresetOption',
  props<any>()
);

export const newDeleteCampaignPresetOptionSuccess = createAction(
  '[Campaign] New Delete Campaign PresetOption Success',
  props<any>()
);

export const newDeleteCampaignPresetOptionFailure = createAction(
  '[Campaign] New Delete Campaign PresetOption Failure',
  props<any>()
);

export const restoreCampaignPresetOption = createAction(
  '[Campaign] Restore Campaign PresetOption',
  props<any>()
);

export const restoreCampaignPresetOptionSuccess = createAction(
  '[Campaign] Restore Campaign PresetOption Success',
  props<any>()
);

export const restoreCampaignPresetOptionFailure = createAction(
  '[Campaign] Restore Campaign PresetOption Failure',
  props<any>()
);

export const deleteCampaignSponsor = createAction(
  '[Campaign] Delete Campaign Sponsor',
  props<any>()
);

export const deleteCampaignSponsorSuccess = createAction(
  '[Campaign] Delete Campaign Sponsor Success',
  props<any>()
);

export const deleteCampaignSponsorFailure = createAction(
  '[Campaign] Delete Campaign Sponsor Failure',
  props<any>()
);